<div class="pageContainer">
  <div class="pageContent">
    <button
      class="btn btn-outline hoverableButton"
      style="margin-bottom: 50px !important;"
      routerLink="home"
    >
      Back to demo timeline
    </button>

    <div class="titleDiv">User Directory</div>
    <div class="subtitleDiv" *ngIf="users && users.length > 0">
      Select a user card to remove that user.
    </div>
    <div class="subtitleDiv" *ngIf="users && users.length <= 0">
      No users are currently stored.
    </div>
    <div class="usersContainer" *ngIf="users">
      <div class="clr-row" *ngFor="let user of users; let idx = index">
        <a class="card clickable" (click)="deleteUser(idx)">
          <div class="card-img">
            <img
              src="{{ user.avatarUrl }}"
              (error)="updateUrl($event)"
              style="width: 400px; height: 200px;"
            />
          </div>
          <div class="card-block">
            <p class="card-text">{{ user.name }}</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
